import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'

const JobsList = () => {
  return (
    <b>jobs</b>
  )
}

export default withStyles(styles)(JobsList)
